import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import isHotkey from 'is-hotkey';
import { ELEMENT_ALIGN_JUSTIFY } from '@udecode/slate-plugins'

import BaseElement from './BaseElement';
import { noop } from 'utils';
import { insertNodeAndScroll } from '../editor-utils'

export function renderClauseElement(params) {
  return (props) => {
    if (props.element.type === 'clause') { 
      return (
          <ClauseElement {...props} {...params} />
      );
    }
  
    return undefined;
  }

}

export function onClauseKeyDown(event, editor) {
    if (!editor.selection) return;

    const currentNode = editor.children[editor.selection.anchor.path[0]];

    if (currentNode.type === 'clause' && isHotkey('shift+enter', event)) {
      event.preventDefault();
      // editor.insertNode({ type: 'clause', block: currentNode.block + 1, number: currentNode.number + 1, children: [{text: ''}]})
      return false;
    }
}

export function insertClause(editor, { block, number, text = '', defaultTextAlign = 'justify' }) {
  const node = {
    type: 'clause', 
    isNew: true,
    block, 
    number, 
    textAlign: defaultTextAlign,
    children: [{ text }]
  }
  insertNodeAndScroll(editor, node)
}


export const ClausePlugin = (params = {}) => ({
  renderElement: renderClauseElement(params),
  renderElementDeps: [params.contract],
  onKeyDown: onClauseKeyDown
});

export default function ClauseElement({ contract = {}, attributes, index, element, children, ...props }) {
  const { t } = useTranslation();
  
  const ordinalNumber = useMemo(() => {
    return element.number ? getOrdinalNumber({number: element.number, t, contract}) : getOrdinalNumber({number: index, t, contract})
  }, [element.number, index, t])

  return (
    <BaseElement className="clause-text" element={element} type="clause" {...props}  {...attributes}>
      {({ isEmpty }) => (
        <React.Fragment>
          <BaseElement.NoEditableField className="item-title" fontWeight="bold" fontSize={element.fontSize}>
            {ordinalNumber}.{' '}
          </BaseElement.NoEditableField>
          { isEmpty && <BaseElement.Placeholder text={t('editor.items.clause')} /> }
          {children}
        </React.Fragment>
      )}
    </BaseElement>
  )
}

export function getOrdinalNumber({number, t, contract = {}}) {
  const options = { lng: (contract.language || 'es').toLowerCase() };
  if (!isNaN(number)) {
    const num = String(number);
    const units = [
      t('ordinals.units.first', options),
      t('ordinals.units.second', options),
      t('ordinals.units.third', options),
      t('ordinals.units.fourth', options),
      t('ordinals.units.fifth', options),
      t('ordinals.units.sixth', options),
      t('ordinals.units.seventh', options),
      t('ordinals.units.eigth', options),
      t('ordinals.units.ninth', options),
    ];
    const dozens = [
      t('ordinals.dozens.tenth', options),
      t('ordinals.dozens.twentieth', options),
      t('ordinals.dozens.thirtieth', options),
      t('ordinals.dozens.fortieth', options),
      t('ordinals.dozens.fiftieth', options),
      t('ordinals.dozens.sixtieth', options),
      t('ordinals.dozens.seventieth', options),
      t('ordinals.dozens.eightieth', options),
      t('ordinals.dozens.ninetieth', options),
    ];
    const hundreds = [
      t('ordinals.hundreds.hundredth', options),
      t('ordinals.hundreds.two_hundredth', options),
      t('ordinals.hundreds.three_hundredth', options),
      t('ordinals.hundreds.four_hundredth', options),
      t('ordinals.hundreds.five_hundredth', options),
      t('ordinals.hundreds.six_hundredth', options),
      t('ordinals.hundreds.seven_hundredth', options),
      t('ordinals.hundreds.eigth_hundredth', options),
      t('ordinals.hundreds.nine_hundredth', options),
    ];
    const array = [units, dozens, hundreds];
    const word = [];
    let index = 0;

    for (let i = num.length; i > 0; i--) {
      const ordinalText = array[index][Number(num[i - 1]) - 1];
      if (ordinalText) {
        word.unshift(ordinalText);
      }
      index++;
    }

    return word.join(' ').toUpperCase();
  }
  return '';
}